var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"supervise-container"},[_c('div',{staticClass:"left-container"},[_c('data-general')],1),_c('div',{staticClass:"right-container"},[_c('map-container')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }